import * as React from 'react';
import { Button, DatePicker, Pagination, Table } from '@roo/roo';
import dayjs from 'dayjs';
import { fen2Yuan } from '@utiljs/lang';
import { useHistory } from 'react-router-dom';
import utils from '@/utils/utils';
import {
    // getInvoiceList,
    // IGetBillDetail,
    getDownLoadTask,
    getBillList,
    getBillCount,
    IGetBillType,
} from '../../api';
import InvoicingModal from './InvoicingModal';

function BillList() {
    const nowSecondStamp = Math.ceil(+new Date() / 1000);
    const [startTime, setStartTime] = React.useState<number>(
        dayjs('2021-01-01', 'YYYY-MM-DD').unix(),
    ); // 开始时间
    const [endTime, setEndTime] = React.useState<number>(nowSecondStamp - 86400); // 结束时间
    const [pageNo, setPageNo] = React.useState<number>(1);
    const [total, setTotal] = React.useState<string>('0');
    const [dataSource, setDataSource] = React.useState<IGetBillType[]>([]);
    const [invoicingVisble, setInvoicingVisble] = React.useState<boolean>(false);
    const history = useHistory();
    // 账单状态 0：待审核，1：审核通过，2：审核驳回
    const invoiceStatusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核驳回',
    };

    const columns: any = [
        { prop: 'id', label: '账单编号', align: 'center' },
        {
            prop: 'startTimeUnix',
            label: '账单周期',
            align: 'center',
            width: '200px',
            render: (text: any, row: any) => (
                <span>
                    {' '}
                    {`${dayjs.unix(text).format('YYYY.MM.DD')} - ${dayjs
                        .unix(row.endTimeUnix)
                        .format('YYYY.MM.DD')}`}
                </span>
            ),
        },
        {
            prop: 'ctime', // 账单生成日期的字段
            label: '账单生成日期',
            align: 'center',
            render: (text: any) => <span>{`${dayjs.unix(text).format('YYYY.MM.DD')}`}</span>,
        },
        {
            prop: 'invoiceAmount',
            label: '开票金额',
            align: 'center',
            render: (text: any) => <span>{fen2Yuan(text)}</span>,
        },
        {
            prop: 'totalAmount',
            label: '账单金额',
            align: 'center',
            render: (text: any) => <span>{fen2Yuan(text)}</span>,
        },
        {
            prop: 'invoiceStatus',
            label: '账单状态',
            align: 'center',
            width: '100px',
            render: (text: 0 | 1 | 2) => invoiceStatusMap[text],
        },
        {
            label: '操作区',
            width: 100,
            align: 'center',
            render: function Operation(text: any, record: IGetBillType) {
                return (
                    <div>
                        <Button
                            type="brand-text"
                            onClick={() => {
                                handleBillSubmit(record.payBillId);
                            }}
                            data-id={record.id}
                        >
                            {record.invoiceStatus === '1' ? '查看发票' : '提交发票'}
                        </Button>
                        <Button
                            type="brand-text"
                            onClick={() => downLoadAndToSee(record)}
                            data-id={record.id}
                        >
                            下载明细
                        </Button>
                    </div>
                );
            },
        },
    ];

    React.useEffect(() => {
        fetchBillList().catch(() => {});
    }, []);

    function downLoadAndToSee(record: any) {
        getDownLoadTask({
            startTimeUnix: record.startTimeUnix,
            endTimeUnix: record.endTimeUnix,
        })
            .then(() => {
                history.push('/settlementTP/download');
            })
            .catch(() => {});
    }

    function handleDatePickerClick(value: Array<number>) {
        setStartTime(value[0]);
        setEndTime(value[1]);
    }

    async function fetchBillList(pageNumber = pageNo) {
        if (!startTime || !endTime) {
            utils.toast('error', '请选择日期');
            return;
        }
        const startTimeV2 = new Date(dayjs.unix(startTime).format('YYYY/MM/DD')).getTime() / 1000;
        const endTimeV2 =
            new Date(dayjs.unix(endTime).format('YYYY/MM/DD')).getTime() / 1000 + 86399;
        let { data: _dataSource } = await getBillList({
            startTime: startTimeV2,
            endTime: endTimeV2,
            pageNo: pageNumber,
            pageSize: 10,
        });
        if (_dataSource == null) {
            _dataSource = [];
        }
        setDataSource(_dataSource);
        const { data: _total } = await getBillCount({
            startTime: startTimeV2,
            endTime: endTimeV2,
            pageNo: pageNumber,
            pageSize: 10,
        });
        setTotal(_total);
        if (pageNumber !== pageNo) {
            setPageNo(pageNumber);
        }
    }

    function handleSearchClick() {
        fetchBillList(1);
    }

    function handlePaginationChange(page: number) {
        fetchBillList(page);
    }

    function handleBillSubmit(payBillId: string) {
        history.push(`/invoice?type=submit&payBillId=${payBillId}`);
    }

    return (
        <div className="billList">
            <div className="bill-search-panel">
                <span>日期选择：</span>
                <DatePicker.RangePicker
                    clearable
                    valueOfType="second"
                    value={[
                        startTime ? startTime.toString() : '',
                        endTime ? endTime.toString() : '',
                    ]}
                    disabledDate={cur =>
                        +cur > Date.now() - 86400000 || +cur < +dayjs('2021-01-01', 'YYYY-MM-DD')
                    }
                    onChange={handleDatePickerClick}
                />
                <Button className="sarch-button" type="brand" onClick={handleSearchClick}>
                    查询
                </Button>
            </div>
            <div className="submit-invoice">
                <Button
                    className="modal-text"
                    type="brand-text"
                    onClick={() => {
                        setInvoicingVisble(true);
                    }}
                >
                    开票须知
                </Button>
            </div>
            <Table columns={columns} data={dataSource} emptyComponent="暂无数据" />
            <Pagination
                total={Number(total)}
                currentPage={pageNo}
                pageSize={10}
                onChange={handlePaginationChange}
            />
            <InvoicingModal
                modalVisible={invoicingVisble}
                closeModal={() => {
                    setInvoicingVisble(false);
                }}
            />
        </div>
    );
}

export default BillList;
